import { render } from "./index.vue?vue&type=template&id=21c6804e"
import script from "./rules.ts?vue&type=script&lang=js"
export * from "./rules.ts?vue&type=script&lang=js"

import "./rules.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script